import i18n from '@/locales'
export default {
  system: {
    options: [
      { id: 'dashboard-system-default', name: i18n.t('dashboard.text_121') },
    ],
    'dashboard-system-default': [
      {
        layout: {
          component: 'NumberCard',
          h: 2,
          w: 5,
          x: 0,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_130'),
          regionAccountType: 'region',
          usage_key: 'all.servers',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 2,
          w: 5,
          x: 5,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_136'),
          regionAccountType: 'region',
          usage_key: 'hosts',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 2,
          w: 5,
          x: 10,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_134'),
          regionAccountType: 'region',
          usage_key: 'baremetals',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 2,
          w: 5,
          x: 15,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_154'),
          regionAccountType: 'region',
          usage_key: 'all.buckets',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 2,
          w: 5,
          x: 0,
          y: 2,
        },
        params: {
          name: i18n.t('dashboard.text_122'),
          regionAccountType: 'region',
          usage_key: 'all.servers.cpu',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 2,
          w: 5,
          x: 5,
          y: 2,
        },
        params: {
          name: i18n.t('dashboard.text_127'),
          regionAccountType: 'region',
          usage_key: 'all.servers.memory',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 2,
          w: 5,
          x: 10,
          y: 2,
        },
        params: {
          name: i18n.t('dashboard.text_123'),
          regionAccountType: 'region',
          usage_key: 'all.servers.disk',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 2,
          w: 5,
          x: 15,
          y: 2,
        },
        params: {
          name: i18n.t('dashboard.text_158'),
          regionAccountType: 'region',
          usage_key: 'all.bucket_bytes',
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 3,
          w: 5,
          x: 0,
          y: 4,
        },
        params: {
          all_usage_key: 'hosts.cpu',
          color: 'default',
          name: i18n.t('dashboard.text_135'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'all.servers.cpu',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 3,
          w: 5,
          x: 5,
          y: 4,
        },
        params: {
          all_usage_key: 'hosts.memory',
          color: 'default',
          name: i18n.t('dashboard.text_132'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'all.servers.memory',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 3,
          w: 5,
          x: 10,
          y: 4,
        },
        params: {
          all_usage_key: 'storages',
          color: 'default',
          name: i18n.t('dashboard.text_128'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'all.servers.disk',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 3,
          w: 5,
          x: 15,
          y: 4,
        },
        params: {
          all_usage_key: 'isolated_devices',
          color: 'default',
          name: i18n.t('dashboard.text_129'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'all.servers.isolated_devices',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 3,
          w: 5,
          x: 0,
          y: 7,
        },
        params: {
          all_usage_key: 'all.eip.floating_ip',
          color: 'reverse',
          name: i18n.t('dashboard.text_156'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'all.eip.floating_ip.used',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 3,
          w: 5,
          x: 5,
          y: 7,
        },
        params: {
          all_usage_key: 'all.ports',
          color: 'default',
          name: i18n.t('dashboard.text_152'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'all.nics',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 3,
          w: 5,
          x: 10,
          y: 7,
        },
        params: {
          all_usage_key: 'all.servers',
          color: 'default',
          name: i18n.t('dashboard.text_151'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.not_shutdown'),
          usage_key: 'all.ready_servers',
          usage_label: i18n.t('dashboard.shutdown'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 3,
          w: 5,
          x: 15,
          y: 7,
        },
        params: {
          all_usage_key: 'all.disks.count',
          color: 'reverse',
          name: i18n.t('dashboard.text_147'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.not_mounted'),
          usage_key: 'all.disks.mounted.count',
          usage_label: i18n.t('dashboard.mounted'),
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 5,
          w: 5,
          x: 0,
          y: 10,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_126'),
          order: 'TOP',
          resType: 'server',
          time: 18000,
          usage: 'usage_active,vm_cpu',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 5,
          w: 5,
          x: 5,
          y: 10,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_133'),
          order: 'TOP',
          resType: 'server',
          time: 18000,
          usage: 'read_bps,vm_diskio',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 5,
          w: 5,
          x: 10,
          y: 10,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_125'),
          order: 'TOP',
          resType: 'server',
          time: 18000,
          usage: 'write_bps,vm_diskio',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 5,
          w: 5,
          x: 15,
          y: 10,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.net.send.top5'),
          order: 'TOP',
          resType: 'server',
          time: 18000,
          usage: 'bps_sent,vm_netio',
        },
      },
    ],
  },
}
